import React from 'react';
import styled from 'styled-components';
import Button from '../Button';
import { motion } from 'framer-motion';

const HeroSection = styled.section`
  background-color: ${props => props.theme.colors.primary};
  background-image: url('/assets/banner.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: ${props => props.theme.colors.white};
  padding: 14rem 0 6rem;
  position: relative;
  overflow: hidden;
  min-height: 10vh;
  overflow-x: hidden;
  overflow-y: visible;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(135deg, rgba(27, 43, 77, 0.97) 0%, rgba(26, 26, 26, 0.85) 100%);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;

  overflow: hidden;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    margin: 0;
    padding: 0;
  }
`;

const Headline = styled(motion.h1)`
  margin-bottom: 1.5rem;
  font-size: ${props => props.theme.fontSizes.h1};
  font-weight: ${props => props.theme.fontWeights.bold};
  color: ${props => props.theme.colors.secondary};
  line-height: ${props => props.theme.lineHeights.tight};
  word-wrap: break-word;
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fontSizes.display};
  }
  
  @media (max-width: 576px) {
    font-size: 2rem;
  }
`;

const Subheadline = styled(motion.h2)`
  font-size: ${props => props.theme.fontSizes.bodyLg};
  font-weight: ${props => props.theme.fontWeights.medium};
  font-family: ${props => props.theme.fonts.subheading};
  margin-bottom: 2.5rem;
  color: ${props => props.theme.colors.grayLighter};
  word-wrap: break-word;
  text-align: center;
  text-justify: inter-word;
  
  @media (max-width: 576px) {
    font-size: 1.1rem;
  }
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: 1.5rem;
  }
`;

const ButtonWrapper = styled(motion.div)`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  will-change: transform;
`;

const Hero = () => {
  const scrollToSection = (id) => {
    const target = document.getElementById(id);
    if (!target) return;
    const headerOffset = 80;
    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  return (
    <HeroSection>
      <div className="container">
        <HeroContent>
          <Headline
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Soluções ágeis e confiáveis em certificação e conformidade técnica.
          </Headline>

          <Subheadline
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Referência em conformidade regulatória, eliminando barreiras e acelerando o acesso ao mercado brasileiro.
          </Subheadline>

          <ButtonWrapper
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <Button
              primary
              size="lg"
              onClick={() => window.open('https://wa.me/5519998621928', '_blank')}
            >
              <i className="fab fa-whatsapp" style={{ marginRight: '10px' }}></i> Solicitar orçamento
            </Button>
            <Button
              primary
              size="lg"
              href="#servicos"
              onClick={() => { scrollToSection('servicos'); }}
            >
              Ver serviços
            </Button>
          </ButtonWrapper>
        </HeroContent>
      </div>
    </HeroSection>
  );
};

export default Hero;
